import { render, staticRenderFns } from "./DiagnosisSensorStep.vue?vue&type=template&id=c2724c40&scoped=true&"
import script from "./DiagnosisSensorStep.vue?vue&type=script&lang=js&"
export * from "./DiagnosisSensorStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2724c40",
  null
  
)

export default component.exports